<template>
  <div>
    <div class="box__svg" style="position: relative;">
      <div v-if="img && !imageLoaded" class="map-loading-overlay">
        <p>Cargando...</p>
      </div>
      <svg v-if="img" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        :viewBox="img.viewBox" xml:space="preserve">
        <image style="overflow: visible" :width="img.width" :height="img.height" :xlink:href="`${img.url}`"
          :transform="img.transform" @load="imageLoaded = true">

        </image>
        <polygon v-show="desarrollo!='torrespaseodelparque'" class="polygon" v-on:mouseover="inLocation(location, index)" v-on:mouseout="outLocation(location, index)"
          @click="selectLocation(location)" v-for="(location, index) in filterIzq" :key="index"
          :points="location.coords_mini_izq" :shape="location.shape" :style="customPolygon(index)"
          :stroke="location.color" :name="`${location.name} ${location.lado}`" 
          :class="{'active':activeLocation==`${location.name} ${location.lado}`}"/>
          <polygon  v-show="desarrollo!='torrespaseodelparque' && torreairea==false" class="polygon" v-on:mouseover="inLocation(location, index)"
          v-on:mouseout="outLocationDer(location, index)" @click="selectLocation(location)"
          v-for="(location, index) in filterDer" :key="'A' + index" :points="desarrollo==='canadas_deptos'? location.coords : location.coords_mini_der"
          :shape="location.shape" :style="customPolygonDer(index)" :stroke="location.color"
          :name="`${location.name} ${location.lado}`" 
          :class="{'active':activeLocation==`${location.name} ${location.lado}`,'active':activeLocation==`${location.name}` && defaultActive==true && desarrollo=='canadas_deptos'}"/>
        <polygon  v-show="desarrollo!='torrespaseodelparque'&& desarrollo!='canadas_deptos'" class="polygon" v-on:mouseover="inLocation(location, index)"
          v-on:mouseout="outLocationDer(location, index)" @click="selectLocation(location)"
          v-for="(location, index) in filterDer" :key="'A-' + index" :points="desarrollo==='canadas_deptos'? location.coords : location.coords_mini_der"
          :shape="location.shape" :style="customPolygonDer(index)" :stroke="location.color"
          :name="`${location.name} ${location.lado}`" 
          :class="{'active':activeLocation==`${location.name} ${location.lado}`}"/>
        <polygon  v-show="desarrollo=='torrespaseodelparque' || desarrollo=='torrevistahermosa'" class="polygon" 
           @click="selectLocation(location)"
          v-for="(location, index) in  filterTorresPP" :key="'Te' + index" :points="location.coordinates || location.coords"
          :shape="location.shape" :style="customPolygonTPP(index)" :stroke="location.color"
          :name="`${location.name}`" 
          :class="{'active':activeLocation==`${location.name}` && defaultActive==true}"
          /><!--  -->
        <!-- <template v-if="desarrollo !== 'torrevistahermosa'"> -->
          <Indicators
            v-for="(indicator, index) in setIndicators"
            :indicator="indicator"
            :key="'T' + indicator.text + index"
            :isTVH="desarrollo === 'torrevistahermosa'"
          />
        <!-- </template>
        <template v-else>
          <Indicators
            v-for="(indicator, index) in setIndicatorsTVH"
            :indicator="indicator"
            :key="'T' + indicator.text + index"
          />
        </template> -->
      </svg>
    </div>

    <map-view-detail v-if="stateMapDetail" />
  </div>
</template>
<script>
/*   import TooltipDeptos from "../../core/TooltipDeptos.vue" */
import { mapActions, mapGetters } from "vuex";
import MapViewDetail from "../../core/MapViewDetail";
import Indicators from "./Indicators.vue";
export default {
  name: "MapHighlightDeptosAirea",
  props: ["existFilter", "img", "url", "nivel", "torre", "torreLevel", "indicators","desarrollo","defaultActive"],
  components: {
    //TooltipDeptos,
    Indicators,
    MapViewDetail
  },
  data() {
    return {
      opacity: 0.4,
      stroke: 3,
      target: null,
      name: "",
      widthViewBox: 1726,
      offIndicator: false,
      onIndicator: true,
      locationsDer: [],
      locationsIzq: [],
      //var active color
      activeLocation: '',
      imageLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      filterModelos: "getStatusFilterModelos",
      stateMapDetail: "getStatusMapDetail",
      selectedLvls: "getSelectedLevel",
      selectedDpt: "getStatusA"
    }),
    filterMapAvaialbles() {
      return this.filterModelos
    },
    filterTorresPP() {
      return this.filterMapAvaialbles.filter((location) => location)
    },
    filterDer() {
      if(this.desarrollo==='canadas_deptos'){
        return this.filterMapAvaialbles.filter((location) => location)
      }else{
        return this.filterMapAvaialbles.filter((location) => location.lado === 'DER')
      }
    },
    filterIzq() {
      return this.filterMapAvaialbles.filter((location) => location.lado === 'IZQ')
    },
    setIndicators() {
      return this.indicators
    },
    torreairea(){
      if(this.desarrollo=='torreaireaplus'){
        return true
      }else{
        return false
      }
    }
  },
  methods: {
    ...mapActions(["selectedLocation", "getLevel", "getAvailableLevels", "getSelectedDpts","getAvailableImageLocation","getAllElements"]),
    selectLocation(location) {
      if(this.torreairea){
        this.selectAvailabilityTorreAirea(location)
      }else{
        this.selectAvailability(location)
      }
    },
    async selectAvailability(location) {
      if (location.available > 0) {
        this.selectedLocation(location)
        let body = {
          name: location.name,
          id: location.id,
          torre: this.torreLevel,
        };
        /* console.log(location) */
        await this.getLevel(body)
       /*  console.log() */
        await this.getAvailableLevels({ id: this.torreLevel, level: location.id });
        this.$emit('activeDetail')
        let elementAvailable = this.selectedLvls.filter((item) => item.available == 1);
        await this.getSelectedDpts(elementAvailable[0]);
       /*  console.log(elementAvailable[0]) */
       
       // await this.getAvailableImageLocation(elementAvailable[0]);
        await this.getAllElements("off");
        this.desactiveBtn();
        this.activeBtn();
        this.activeLocation=`${location.name}`
        /*  console.log(this.selectedDpt) */
        //let nameNoSpace = location.name.replace(/ /g, "");
        //console.log(nameNoSpace)
        /* this.$router.push({path: `${this.url}/cve_nivel_te=${location.id}/nombre_nivel_te=${nameNoSpace}`,
        }) */
      } else {
        event.preventDefault();

      }
    },
    async selectAvailabilityTorreAirea(location) {
      if (location.available > 0) {
        this.selectedLocation(location)
        let body = {
          name: location.name,
          id: location.id,
          torre: this.torreLevel,
          lado:location.lado
        };
        /* console.log(location) */
        await this.getLevel(body)
       
        /* console.log({id: this.torreLevel, level: location.id}) */
        
        await this.getAvailableLevels({ id: this.torreLevel, level: location.id });
        let elementAvailable = this.selectedLvls.filter((item) => item.available == 1 || item.reserved ==1 );
        if(location.lado=="IZQ"){
          let elementSide = elementAvailable.filter((item)=>item.name.includes('A'))
          await this.getSelectedDpts(elementSide[0]);
          await this.getAvailableImageLocation(elementSide[0]);
        }else if(location.lado=="DER"){
          let elementSide = elementAvailable.filter((item)=>item.name.includes('B'))
          await this.getSelectedDpts(elementSide[0]);
          await this.getAvailableImageLocation(elementSide[0]);
        }
        this.$emit('activeDetail');
        this.activeLocation=`${location.name} ${location.lado}`
        
      } else {
        event.preventDefault();

      }
    },
    inLocation(location) {
      this.name = location.name
      event.target.style.opacity = 0.3;
      event.target.style.fill = "#" + location.color;
    },
    outLocation(location, index) {
      this.name = "";
      event.target.style.opacity = 0.4;
      event.target.style.fill = `#${this.filterIzq[index].color}`;
    },
    outLocationDer(location, index) {
      this.name = "";
      event.target.style.opacity = 0.4;
      event.target.style.fill = `#${this.filterDer[index].color}`;
    },
    customPolygon(index) {
      let location = this.filterIzq[index];
      return `stroke-width:3; stroke:#${location.color}; opacity: ${this.opacity}; fill: #${location.color}`;
    },
    customPolygonDer(index) {
      let location = this.filterDer[index];
      return `stroke-width:3; stroke:#${location.color}; opacity: ${this.opacity}; fill: #${location.color}`;
    },
    customPolygonTPP(index) {
      let location = this.filterTorresPP[index];
      return `stroke-width:3; stroke:#${location.color}; opacity: ${this.opacity}; fill: #${location.color}`;
    },
    desactiveBtn() {
            let btns = document.querySelectorAll('.btn__model-container button');
            /*  let cont = 0; */

            for (let index = 0; index < btns.length; index++) {
                const element = btns[index];

                if (element.getAttribute("disabled") != "disabled") {
                    element.classList.remove('btn__model-active')
                }

            }
        },
    activeBtn() {
      setTimeout(() => {
        let btns = document.querySelectorAll('.btn__model-container button');
      /*  let cont = 0; */

      for (let index = 0; index < btns.length; index++) {
        const element = btns[index];

        if (element.getAttribute("disabled") != "disabled") {
          if (index == 0) {
            element.classList.add('btn__model-active')
            break;
          } else {
            element.classList.add('btn__model-active')
          }
        }

      }
      }, 500);

    },
    beforeDestroy() {
      this.indicators = [];
      //restart var active color
      this.activeLocation=''
    }
  },
};
</script>
<style>
.map-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  text-align: center;
  padding: 50px 0;
  background: #fff;
}
.polygon.active{
  fill: #152541!important;
  stroke: #152541!important;
  opacity: 0.7!important;
}
</style>
  
  
  
  
  